import flatpickr from 'flatpickr';

const globalConfig = {
  locale: { firstDayOfWeek: 1 },
  altInput: true,
  time_24hr: true,
  minuteIncrement: 1,
  altFormat: 'd.m.Y',
};

const timePickerConfig = {
  allowInput: true,
  dateFormat: 'H:i',
  enableTime: true,
  noCalendar: true,
  time_24hr: true,
};

export function initDatepicker(config = {}, targetEl) {
  const target = targetEl || document;
  flatpickr.localize({ firstDayOfWeek: 1 });

  target.querySelectorAll('.datepicker').forEach((e) => {
    const disablePast = Boolean(e.dataset.disablePast);
    const disableFuture = Boolean(e.dataset.disableFuture);
    const enableTime = Boolean(e.dataset.enableTime);
    const timeOnly = Boolean(e.dataset.timeOnly);

    const datePickerConfig = {
      ...globalConfig,
      ...(enableTime ? { altFormat: 'd.m.Y H:i' } : {}),
      ...config,
      minDate: disablePast ? new Date() : null,
      maxDate: disableFuture ? new Date() : null,
      enableTime: enableTime,
    };

    flatpickr(e, timeOnly ? timePickerConfig : datePickerConfig);
  });
}
